/**
 * prenotazione API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum PrenotazioneStatusEnum {

    DaApprovare = 'DA_APPROVARE',

    Nuovo = 'NUOVO',

    Inviato = 'INVIATO',

    InLavorazione = 'IN_LAVORAZIONE',

    DaAnnullare = 'DA_ANNULLARE',

    DaAnnullarePerModifica = 'DA_ANNULLARE_PER_MODIFICA',

    InviatoRegistroArera = 'INVIATO_REGISTRO_ARERA',

    AnnullatoPerModifica = 'ANNULLATO_PER_MODIFICA',

    InAnnullamento = 'IN_ANNULLAMENTO',

    Annullato = 'ANNULLATO',

    Confermato = 'CONFERMATO',

    Eseguito = 'ESEGUITO',

    NonEseguito = 'NON_ESEGUITO'
}

